import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { GirisComponent } from './modules/giris/giris.component';
import { GirisFormComponent } from './modules/giris/giris-form/giris-form.component';
import { YonetimComponent } from './modules/yonetim/yonetim.component';
import { YonetimAnasayfaComponent } from './modules/yonetim/yonetim-anasayfa/yonetim-anasayfa.component';
import { SiteComponent } from './modules/site/site.component';
import { AnasayfaComponent } from './modules/site/anasayfa/anasayfa.component';
import { SolMenuComponent } from './modules/yonetim/components/sol-menu/sol-menu.component';
import { UstMenuComponent } from './modules/yonetim/components/ust-menu/ust-menu.component';
import { AltMenuComponent } from './modules/yonetim/components/alt-menu/alt-menu.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { BulunamadiComponent } from './modules/hata/bulunamadi/bulunamadi.component';
import { LoadingComponent } from './components/loading/loading.component';
import { GridComponent } from './components/grid/grid.component';
import { SubmitButtonComponent } from './components/submit-button/submit-button.component';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { KullaniciTalepBilgiComponent } from './modules/yonetim/kullanici-talep-bilgi/kullanici-talep-bilgi.component';
import { KullaniciTalepIslemComponent } from './modules/yonetim/kullanici-talep-bilgi/kullanici-talep-islem/kullanici-talep-islem.component';
import { ProfilComponent } from './modules/yonetim/profil/profil.component';
import { ProfilIslemComponent } from './modules/yonetim/profil/profil-islem/profil-islem.component';
import { KullaniciTalepAyrintiComponent } from './modules/yonetim/kullanici-talep-bilgi/kullanici-talep-ayrinti/kullanici-talep-ayrinti.component';



@NgModule({
  declarations: [
    AppComponent,
    GirisComponent,
    GirisFormComponent,
    YonetimComponent,
    YonetimAnasayfaComponent,
    SiteComponent,
    AnasayfaComponent,
    SolMenuComponent,
    UstMenuComponent,
    AltMenuComponent,
    BulunamadiComponent,
    LoadingComponent,
    GridComponent,
    SubmitButtonComponent,
    KullaniciTalepBilgiComponent,
    KullaniciTalepIslemComponent,
    ProfilComponent,
    ProfilIslemComponent,
    KullaniciTalepAyrintiComponent,
  ],
 
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    FormsModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
